// You can write more code here

import { CosmeticShopController } from '@/game/GameComponents/PhaserGame/Scenes/CosmeticShop/CosmeticShopController';
import PurchaseNotification from '@/game/prefabs/CosmeticShop/PurchaseNotification';
import ShopGridItem from '@/game/prefabs/CosmeticShop/ShopGridItem';
import ShopTab from '@/game/prefabs/CosmeticShop/ShopTab';
import ShopTab_m from '@/game/prefabs/CosmeticShop/ShopTab_m';
import DefaultConfirmButton_m from '@/game/prefabs/DefaultConfirmButton_m';
import DefaultButton from '@/game/prefabs/GeneralUI/Buttons/DefaultButton';
import HUDButton from '@/game/prefabs/GeneralUI/Buttons/HUDButton';
import PlayerDoll from '@/game/prefabs/GeneralUI/PlayerDoll';
import UIBlocker from '@/game/prefabs/GeneralUI/UIBlocker';

/* START OF COMPILED CODE */

export default class CosmeticShop extends Phaser.Scene {

	constructor() {
		super("CosmeticShop");

		/* START-USER-CTR-CODE */

    /* END-USER-CTR-CODE */
	}

	editorCreate(): void {

		// desktopView
		const desktopView = this.add.container(0, 0);
		desktopView.visible = false;

		// uIBlocker
		const uIBlocker = new UIBlocker(this, 0, 0);
		desktopView.add(uIBlocker);

		// mainContainer
		const mainContainer = this.add.container(512, 384);
		desktopView.add(mainContainer);

		// playerViewContainer
		const playerViewContainer = this.add.container(-512, -384);
		mainContainer.add(playerViewContainer);

		// previewContainer
		const previewContainer = this.add.container(64, 504);
		playerViewContainer.add(previewContainer);

		// mainShopContainer
		const mainShopContainer = this.add.container(-398, -320);
		mainContainer.add(mainShopContainer);

		// backing_1
		const backing_1 = this.add.nineslice(-10, -8, "Hud1", undefined, 204, 164, 8, 8, 8, 8);
		backing_1.scaleX = 4;
		backing_1.scaleY = 4;
		backing_1.setOrigin(0, 0);
		mainShopContainer.add(backing_1);

		// header
		const header = this.add.container(382, 0);
		mainShopContainer.add(header);

		// headerBacking
		const headerBacking = this.add.nineslice(0, 0, "Hud2", undefined, 90, 18, 4, 4, 4, 8);
		headerBacking.scaleX = 4;
		headerBacking.scaleY = 4;
		header.add(headerBacking);

		// bitmaptext_2
		const bitmaptext_2 = this.add.bitmapText(0, 0, "Aronui", "Spellcaster Shop");
		bitmaptext_2.setOrigin(0.5, 0.5);
		bitmaptext_2.tintTopLeft = 985612;
		bitmaptext_2.tintTopRight = 985612;
		bitmaptext_2.tintBottomLeft = 985612;
		bitmaptext_2.tintBottomRight = 985612;
		bitmaptext_2.text = "Spellcaster Shop";
		bitmaptext_2.fontSize = -30;
		header.add(bitmaptext_2);

		// leaveButton
		const leaveButton = new DefaultButton(this, 382, 632);
		leaveButton.visible = false;
		mainShopContainer.add(leaveButton);

		// shopTabs
		const shopTabs = this.add.container(18, 128);
		mainShopContainer.add(shopTabs);

		// shopTab
		const shopTab = new ShopTab(this, 0, 0);
		shopTabs.add(shopTab);

		// mainShopGrid
		const mainShopGrid = this.add.container(162, 116);
		mainShopContainer.add(mainShopGrid);

		// gridBacking
		const gridBacking = this.add.nineslice(0, 0, "panel segment", undefined, 155, 128, 4, 4, 4, 8);
		gridBacking.scaleX = 4;
		gridBacking.scaleY = 4;
		gridBacking.setOrigin(0, 0);
		mainShopGrid.add(gridBacking);

		// gridScrollBar
		const gridScrollBar = this.add.container(608, 12);
		mainShopGrid.add(gridScrollBar);

		// scrollBarBacking
		const scrollBarBacking = this.add.nineslice(0, 0, "scrollbar-backing", undefined, 8, 124, 2, 2, 2, 2);
		scrollBarBacking.scaleX = 4;
		scrollBarBacking.scaleY = 4;
		scrollBarBacking.setOrigin(0.5, 0);
		gridScrollBar.add(scrollBarBacking);

		// scrollBarHandle
		const scrollBarHandle = this.add.image(0, 0, "scrollbar-handle");
		scrollBarHandle.scaleX = 4;
		scrollBarHandle.scaleY = 4;
		scrollBarHandle.setOrigin(0.5, 0);
		gridScrollBar.add(scrollBarHandle);

		// content
		const content = this.add.container(0, 0);
		mainShopGrid.add(content);

		// loadingContainer
		const loadingContainer = this.add.container(0, 0);
		mainShopGrid.add(loadingContainer);

		// spinnerBlocker
		const spinnerBlocker = this.add.image(-148, 0, "1x1sprite");
		spinnerBlocker.scaleX = 768;
		spinnerBlocker.scaleY = 512;
		spinnerBlocker.setOrigin(0, 0);
		spinnerBlocker.alpha = 0.3;
		spinnerBlocker.alphaTopLeft = 0.31;
		spinnerBlocker.alphaTopRight = 0.3;
		spinnerBlocker.alphaBottomLeft = 0.3;
		spinnerBlocker.alphaBottomRight = 0.3;
		spinnerBlocker.tintTopLeft = 985612;
		spinnerBlocker.tintTopRight = 985612;
		spinnerBlocker.tintBottomLeft = 985612;
		spinnerBlocker.tintBottomRight = 985612;
		loadingContainer.add(spinnerBlocker);

		// loadingSpinner
		const loadingSpinner = this.add.image(310, 238, "loading-spinner_512x512");
		loadingSpinner.scaleX = 0.1;
		loadingSpinner.scaleY = 0.1;
		loadingContainer.add(loadingSpinner);

		// categoryHeader
		const categoryHeader = this.add.container(92, 0);
		categoryHeader.visible = false;
		mainShopGrid.add(categoryHeader);

		// nineslice_1
		const nineslice_1 = this.add.nineslice(0, 0, "backingFadeOut", undefined, 32, 8, 4, 4, 4, 4);
		nineslice_1.scaleX = 4;
		nineslice_1.scaleY = 4;
		categoryHeader.add(nineslice_1);

		// categoryHeaderText
		const categoryHeaderText = this.add.bitmapText(-56, 0, "Aronui", "Clothes");
		categoryHeaderText.setOrigin(0, 0.5);
		categoryHeaderText.tintTopLeft = 15130076;
		categoryHeaderText.tintTopRight = 15130076;
		categoryHeaderText.tintBottomLeft = 15130076;
		categoryHeaderText.tintBottomRight = 15130076;
		categoryHeaderText.text = "Clothes";
		categoryHeaderText.fontSize = -16;
		categoryHeader.add(categoryHeaderText);

		// allItemsBoughtContainer
		const allItemsBoughtContainer = this.add.container(0, 0);
		mainShopGrid.add(allItemsBoughtContainer);

		// allItemsBoughtTitle
		const allItemsBoughtTitle = this.add.bitmapText(160, 48, "Aronui", "No more items :(");
		allItemsBoughtTitle.tintTopLeft = 985612;
		allItemsBoughtTitle.tintTopRight = 985612;
		allItemsBoughtTitle.tintBottomLeft = 985612;
		allItemsBoughtTitle.tintBottomRight = 985612;
		allItemsBoughtTitle.text = "No more items :(";
		allItemsBoughtTitle.fontSize = -24;
		allItemsBoughtContainer.add(allItemsBoughtTitle);

		// allItemsBoughtDescription
		const allItemsBoughtDescription = this.add.bitmapText(160, 76, "Aronui", "You already own all the items in this category. We will add more in the future!");
		allItemsBoughtDescription.tintTopLeft = 5387071;
		allItemsBoughtDescription.tintTopRight = 5387071;
		allItemsBoughtDescription.tintBottomLeft = 5387071;
		allItemsBoughtDescription.tintBottomRight = 5387071;
		allItemsBoughtDescription.text = "You already own all the items in this category. We will add more in the future!";
		allItemsBoughtDescription.fontSize = -18;
		allItemsBoughtDescription.maxWidth = 400;
		allItemsBoughtContainer.add(allItemsBoughtDescription);

		// shopIcon
		const shopIcon = this.add.image(116, 84, "shop1");
		shopIcon.scaleX = 4;
		shopIcon.scaleY = 4;
		allItemsBoughtContainer.add(shopIcon);

		// crossIcon
		const crossIcon = this.add.image(116, 88, "hud-icons", 133);
		crossIcon.scaleX = 4;
		crossIcon.scaleY = 4;
		allItemsBoughtContainer.add(crossIcon);

		// currency
		const currency = this.add.container(642, 76);
		mainShopContainer.add(currency);

		// currencyBacking
		const currencyBacking = this.add.nineslice(16, 16, "backingFadeOut", undefined, 31, 0, 2, 5, 0, 0);
		currencyBacking.scaleX = 4;
		currencyBacking.scaleY = 4;
		currencyBacking.setOrigin(0, 0.5);
		currency.add(currencyBacking);

		// ruby-icon
		const ruby_icon = this.add.image(16, 16, "ruby-small");
		ruby_icon.scaleX = 4;
		ruby_icon.scaleY = 4;
		currency.add(ruby_icon);

		// playerRubiesText
		const playerRubiesText = this.add.bitmapText(128, 16, "Aronui", "-");
		playerRubiesText.setOrigin(1, 0.5);
		playerRubiesText.tintTopLeft = 15130076;
		playerRubiesText.tintTopRight = 15130076;
		playerRubiesText.tintBottomLeft = 15130076;
		playerRubiesText.tintBottomRight = 15130076;
		playerRubiesText.text = "-";
		playerRubiesText.fontSize = -24;
		playerRubiesText.align = 2;
		currency.add(playerRubiesText);

		// closeButtonContainer
		const closeButtonContainer = this.add.container(806, -8);
		closeButtonContainer.scaleX = 2;
		closeButtonContainer.scaleY = 2;
		mainShopContainer.add(closeButtonContainer);

		// closeButton
		const closeButton = new HUDButton(this, -24, 24, "hud-icons", 245);
		closeButtonContainer.add(closeButton);

		// purchaseNotificationOrigin
		const purchaseNotificationOrigin = this.add.container(916, 180);
		desktopView.add(purchaseNotificationOrigin);

		// purchaseNotification
		const purchaseNotification = new PurchaseNotification(this, 0, 0);
		purchaseNotificationOrigin.add(purchaseNotification);

		// itemViewModal
		const itemViewModal = this.add.container(0, 0);
		itemViewModal.visible = false;
		desktopView.add(itemViewModal);

		// itemViewBacking
		const itemViewBacking = this.add.image(0, 0, "1x1sprite");
		itemViewBacking.scaleX = 2048;
		itemViewBacking.scaleY = 1536;
		itemViewBacking.alpha = 0.5;
		itemViewBacking.alphaTopLeft = 0.5;
		itemViewBacking.alphaTopRight = 0.5;
		itemViewBacking.alphaBottomLeft = 0.5;
		itemViewBacking.alphaBottomRight = 0.5;
		itemViewBacking.tintTopLeft = 985612;
		itemViewBacking.tintTopRight = 985612;
		itemViewBacking.tintBottomLeft = 985612;
		itemViewBacking.tintBottomRight = 985612;
		itemViewModal.add(itemViewBacking);

		// itemViewContainer
		const itemViewContainer = this.add.container(0, 0);
		itemViewModal.add(itemViewContainer);

		// itemViewContainerBG
		const itemViewContainerBG = this.add.nineslice(0, 0, "Hud1", undefined, 120, 144, 8, 8, 8, 8);
		itemViewContainerBG.scaleX = 4;
		itemViewContainerBG.scaleY = 4;
		itemViewContainer.add(itemViewContainerBG);

		// itemViewAcceptButton
		const itemViewAcceptButton = new DefaultButton(this, 0, 240);
		itemViewContainer.add(itemViewAcceptButton);

		// itemIconContainer
		const itemIconContainer = this.add.container(-88, -80);
		itemViewContainer.add(itemIconContainer);

		// itemIconBacking
		const itemIconBacking = this.add.nineslice(0, 0, "modalFrame", undefined, 128, 128, 2, 2, 2, 4);
		itemIconBacking.scaleX = 2;
		itemIconBacking.scaleY = 2;
		itemIconContainer.add(itemIconBacking);

		// itemView
		const itemView = this.add.image(0, 0, "ui-black-high-boots-large");
		itemView.scaleX = 4;
		itemView.scaleY = 4;
		itemIconContainer.add(itemView);

		// itemViewRarityFrame
		const itemViewRarityFrame = this.add.nineslice(0, 0, "frame-common", undefined, 128, 128, 4, 4, 4, 4);
		itemViewRarityFrame.scaleX = 2;
		itemViewRarityFrame.scaleY = 2;
		itemIconContainer.add(itemViewRarityFrame);

		// itemInfoContainer
		const itemInfoContainer = this.add.container(-216, 64);
		itemViewContainer.add(itemInfoContainer);

		// itemIconBacking_1
		const itemIconBacking_1 = this.add.nineslice(0, 0, "panel segment", undefined, 108, 36, 4, 4, 4, 8);
		itemIconBacking_1.scaleX = 4;
		itemIconBacking_1.scaleY = 4;
		itemIconBacking_1.setOrigin(0, 0);
		itemInfoContainer.add(itemIconBacking_1);

		// itemViewItemName
		const itemViewItemName = this.add.bitmapText(16, 16, "Aronui", "Black Boots");
		itemViewItemName.tintTopLeft = 985612;
		itemViewItemName.tintTopRight = 985612;
		itemViewItemName.tintBottomLeft = 985612;
		itemViewItemName.tintBottomRight = 985612;
		itemViewItemName.text = "Black Boots";
		itemViewItemName.fontSize = -24;
		itemViewItemName.maxWidth = 240;
		itemInfoContainer.add(itemViewItemName);

		// itemPriceLabel
		const itemPriceLabel = this.add.bitmapText(276, 68, "Aronui", "Price:");
		itemPriceLabel.setOrigin(1, 0);
		itemPriceLabel.tintTopLeft = 5387071;
		itemPriceLabel.tintTopRight = 5387071;
		itemPriceLabel.tintBottomLeft = 5387071;
		itemPriceLabel.tintBottomRight = 5387071;
		itemPriceLabel.text = "Price:";
		itemPriceLabel.fontSize = -16;
		itemPriceLabel.maxWidth = 120;
		itemInfoContainer.add(itemPriceLabel);

		// currency_2
		const currency_2 = this.add.container(284, 60);
		itemInfoContainer.add(currency_2);

		// currencyBacking_1
		const currencyBacking_1 = this.add.nineslice(16, 16, "backingFadeOut", undefined, 31, 0, 2, 5, 0, 0);
		currencyBacking_1.scaleX = 4;
		currencyBacking_1.scaleY = 4;
		currencyBacking_1.setOrigin(0, 0.5);
		currency_2.add(currencyBacking_1);

		// ruby-icon_2
		const ruby_icon_2 = this.add.image(16, 16, "ruby-small");
		ruby_icon_2.scaleX = 4;
		ruby_icon_2.scaleY = 4;
		currency_2.add(ruby_icon_2);

		// itemPriceText
		const itemPriceText = this.add.bitmapText(124, 16, "Aronui", "100000");
		itemPriceText.setOrigin(1, 0.5);
		itemPriceText.tintTopLeft = 15130076;
		itemPriceText.tintTopRight = 15130076;
		itemPriceText.tintBottomLeft = 15130076;
		itemPriceText.tintBottomRight = 15130076;
		itemPriceText.text = "100000";
		itemPriceText.fontSize = -24;
		itemPriceText.align = 2;
		currency_2.add(itemPriceText);

		// currency_3
		const currency_3 = this.add.container(284, 96);
		itemInfoContainer.add(currency_3);

		// currencyBacking_2
		const currencyBacking_2 = this.add.nineslice(16, 16, "backingFadeOut", undefined, 31, 0, 2, 5, 0, 0);
		currencyBacking_2.scaleX = 4;
		currencyBacking_2.scaleY = 4;
		currencyBacking_2.setOrigin(0, 0.5);
		currency_3.add(currencyBacking_2);

		// ruby-icon_3
		const ruby_icon_3 = this.add.image(16, 16, "ruby-small");
		ruby_icon_3.scaleX = 4;
		ruby_icon_3.scaleY = 4;
		currency_3.add(ruby_icon_3);

		// playerRubiesText_1
		const playerRubiesText_1 = this.add.bitmapText(124, 16, "Aronui", "-");
		playerRubiesText_1.setOrigin(1, 0.5);
		playerRubiesText_1.tintTopLeft = 15130076;
		playerRubiesText_1.tintTopRight = 15130076;
		playerRubiesText_1.tintBottomLeft = 15130076;
		playerRubiesText_1.tintBottomRight = 15130076;
		playerRubiesText_1.text = "-";
		playerRubiesText_1.fontSize = -24;
		playerRubiesText_1.align = 2;
		currency_3.add(playerRubiesText_1);

		// availableFundsLabel
		const availableFundsLabel = this.add.bitmapText(276, 104, "Aronui", "You have:");
		availableFundsLabel.setOrigin(1, 0);
		availableFundsLabel.tintTopLeft = 5387071;
		availableFundsLabel.tintTopRight = 5387071;
		availableFundsLabel.tintBottomLeft = 5387071;
		availableFundsLabel.tintBottomRight = 5387071;
		availableFundsLabel.text = "You have:";
		availableFundsLabel.fontSize = -16;
		availableFundsLabel.maxWidth = 120;
		itemInfoContainer.add(availableFundsLabel);

		// rarityBacking
		const rarityBacking = this.add.nineslice(352, 36, "backingFadeOut", undefined, 36, 10, 4, 4, 4, 4);
		rarityBacking.scaleX = 4;
		rarityBacking.scaleY = 4;
		itemInfoContainer.add(rarityBacking);

		// rarityText
		const rarityText = this.add.bitmapText(292, 36, "Aronui", "Common");
		rarityText.setOrigin(0, 0.5);
		rarityText.tintTopLeft = 2989040;
		rarityText.tintTopRight = 2989040;
		rarityText.tintBottomLeft = 2989040;
		rarityText.tintBottomRight = 2989040;
		rarityText.text = "Common";
		rarityText.fontSize = -20;
		rarityText.maxWidth = 140;
		itemInfoContainer.add(rarityText);

		// playerContainer_1
		const playerContainer_1 = this.add.container(136, -80);
		itemViewContainer.add(playerContainer_1);

		// playerBacking_1
		const playerBacking_1 = this.add.nineslice(0, 0, "panel segment", undefined, 40, 64, 4, 4, 4, 4);
		playerBacking_1.scaleX = 4;
		playerBacking_1.scaleY = 4;
		playerContainer_1.add(playerBacking_1);

		// image_8
		const image_8 = this.add.image(0, 0, "zone-snippet");
		playerContainer_1.add(image_8);

		// playerDoll
		const playerDoll = new PlayerDoll(this, 0, 0);
		playerContainer_1.add(playerDoll);

		// itemViewHeaderContainer
		const itemViewHeaderContainer = this.add.container(0, -280);
		itemViewContainer.add(itemViewHeaderContainer);

		// itemViewHeaderBG
		const itemViewHeaderBG = this.add.nineslice(0, 0, "Hud2", undefined, 64, 16, 4, 4, 4, 4);
		itemViewHeaderBG.scaleX = 4;
		itemViewHeaderBG.scaleY = 4;
		itemViewHeaderContainer.add(itemViewHeaderBG);

		// itemViewTitle
		const itemViewTitle = this.add.bitmapText(0, 0, "Aronui", "Purchase Item");
		itemViewTitle.setOrigin(0.5, 0.5);
		itemViewTitle.tintTopLeft = 985612;
		itemViewTitle.tintTopRight = 985612;
		itemViewTitle.tintBottomLeft = 985612;
		itemViewTitle.tintBottomRight = 985612;
		itemViewTitle.text = "Purchase Item";
		itemViewTitle.fontSize = -24;
		itemViewHeaderContainer.add(itemViewTitle);

		// closeButtonContainer_1
		const closeButtonContainer_1 = this.add.container(240, -288);
		closeButtonContainer_1.scaleX = 2;
		closeButtonContainer_1.scaleY = 2;
		itemViewContainer.add(closeButtonContainer_1);

		// closeButton_1
		const closeButton_1 = new HUDButton(this, -24, 24, "hud-icons", 245);
		closeButtonContainer_1.add(closeButton_1);

		// mobileView
		const mobileView = this.add.container(0, 0);

		// uIBlocker_m
		const uIBlocker_m = new UIBlocker(this, 0, 0);
		mobileView.add(uIBlocker_m);

		// mainContainer_m
		const mainContainer_m = this.add.container(334, 188);
		mobileView.add(mainContainer_m);

		// playerViewContainer_m
		const playerViewContainer_m = this.add.container(-512, -384);
		mainContainer_m.add(playerViewContainer_m);

		// previewContainer_m
		const previewContainer_m = this.add.container(64, 504);
		playerViewContainer_m.add(previewContainer_m);

		// mainShopContainer_m
		const mainShopContainer_m = this.add.container(0, 0);
		mainContainer_m.add(mainShopContainer_m);

		// backing_m
		const backing_m = this.add.nineslice(0, 0, "Hud1", undefined, 302, 156, 8, 8, 8, 8);
		backing_m.scaleX = 2;
		backing_m.scaleY = 2;
		mainShopContainer_m.add(backing_m);

		// header_m
		const header_m = this.add.container(6, -152);
		mainShopContainer_m.add(header_m);

		// headerBacking_m
		const headerBacking_m = this.add.nineslice(0, 0, "Hud2", undefined, 120, 22, 4, 4, 2, 4);
		headerBacking_m.scaleX = 2;
		headerBacking_m.scaleY = 2;
		header_m.add(headerBacking_m);

		// bitmaptext_m
		const bitmaptext_m = this.add.bitmapText(-4, -2, "Aronui", "Spellcaster Shop");
		bitmaptext_m.setOrigin(0.5, 0.5);
		bitmaptext_m.tintTopLeft = 3023407;
		bitmaptext_m.tintTopRight = 3023407;
		bitmaptext_m.tintBottomLeft = 3023407;
		bitmaptext_m.tintBottomRight = 3023407;
		bitmaptext_m.text = "Spellcaster Shop";
		bitmaptext_m.fontSize = -24;
		header_m.add(bitmaptext_m);

		// shopTabs_m
		const shopTabs_m = this.add.container(-262, -82);
		mainShopContainer_m.add(shopTabs_m);

		// shopTab_m
		const shopTab_m = new ShopTab_m(this, 0, 0);
		shopTabs_m.add(shopTab_m);

		// mainShopGrid_m
		const mainShopGrid_m = this.add.container(-286, -64);
		mainShopContainer_m.add(mainShopGrid_m);

		// gridBacking_m
		const gridBacking_m = this.add.nineslice(0, 0, "panel segment", undefined, 286, 102, 4, 4, 4, 8);
		gridBacking_m.scaleX = 2;
		gridBacking_m.scaleY = 2;
		gridBacking_m.setOrigin(0, 0);
		mainShopGrid_m.add(gridBacking_m);

		// content_m
		const content_m = this.add.container(0, 0);
		mainShopGrid_m.add(content_m);

		// shopGridItem
		const shopGridItem = new ShopGridItem(this, 8, 8);
		shopGridItem.visible = false;
		content_m.add(shopGridItem);

		// shopGridItem_1
		const shopGridItem_1 = new ShopGridItem(this, 146, 8);
		shopGridItem_1.visible = false;
		content_m.add(shopGridItem_1);

		// shopGridItem_2
		const shopGridItem_2 = new ShopGridItem(this, 284, 8);
		shopGridItem_2.visible = false;
		content_m.add(shopGridItem_2);

		// shopGridItem_3
		const shopGridItem_3 = new ShopGridItem(this, 422, 8);
		shopGridItem_3.visible = false;
		content_m.add(shopGridItem_3);

		// gridScrollBar_m
		const gridScrollBar_m = this.add.container(564, 0);
		mainShopGrid_m.add(gridScrollBar_m);

		// scrollBarBacking_m
		const scrollBarBacking_m = this.add.nineslice(0, 0, "scrollbar-backing", undefined, 8, 102, 2, 2, 2, 2);
		scrollBarBacking_m.scaleX = 2;
		scrollBarBacking_m.scaleY = 2;
		scrollBarBacking_m.setOrigin(0.5, 0);
		gridScrollBar_m.add(scrollBarBacking_m);

		// scrollBarHandle_m
		const scrollBarHandle_m = this.add.image(0, 0, "scrollbar-handle");
		scrollBarHandle_m.scaleX = 2;
		scrollBarHandle_m.scaleY = 2;
		scrollBarHandle_m.setOrigin(0.5, 0);
		gridScrollBar_m.add(scrollBarHandle_m);

		// loadingContainer_m
		const loadingContainer_m = this.add.container(0, 0);
		mainShopGrid_m.add(loadingContainer_m);

		// spinnerBlocker_m
		const spinnerBlocker_m = this.add.image(0, 0, "1x1sprite");
		spinnerBlocker_m.scaleX = 572;
		spinnerBlocker_m.scaleY = 228;
		spinnerBlocker_m.setOrigin(0, 0);
		spinnerBlocker_m.alpha = 0.3;
		spinnerBlocker_m.alphaTopLeft = 0.31;
		spinnerBlocker_m.alphaTopRight = 0.3;
		spinnerBlocker_m.alphaBottomLeft = 0.3;
		spinnerBlocker_m.alphaBottomRight = 0.3;
		spinnerBlocker_m.tintTopLeft = 985612;
		spinnerBlocker_m.tintTopRight = 985612;
		spinnerBlocker_m.tintBottomLeft = 985612;
		spinnerBlocker_m.tintBottomRight = 985612;
		loadingContainer_m.add(spinnerBlocker_m);

		// loadingSpinner_m
		const loadingSpinner_m = this.add.image(286, 102, "loading-spinner_512x512");
		loadingSpinner_m.scaleX = 0.1;
		loadingSpinner_m.scaleY = 0.1;
		loadingContainer_m.add(loadingSpinner_m);

		// allItemsBoughtContainer_m
		const allItemsBoughtContainer_m = this.add.container(4, 4);
		allItemsBoughtContainer_m.visible = false;
		mainShopGrid_m.add(allItemsBoughtContainer_m);

		// allItemsBoughtTitle_m
		const allItemsBoughtTitle_m = this.add.bitmapText(92, 25, "Aronui", "No more items :(");
		allItemsBoughtTitle_m.setOrigin(0, 0.5);
		allItemsBoughtTitle_m.tintTopLeft = 985612;
		allItemsBoughtTitle_m.tintTopRight = 985612;
		allItemsBoughtTitle_m.tintBottomLeft = 985612;
		allItemsBoughtTitle_m.tintBottomRight = 985612;
		allItemsBoughtTitle_m.text = "No more items :(";
		allItemsBoughtTitle_m.fontSize = -18;
		allItemsBoughtContainer_m.add(allItemsBoughtTitle_m);

		// allItemsBoughtDescription_m
		const allItemsBoughtDescription_m = this.add.bitmapText(92, 37, "Aronui", "You already own all the items in this category. We will add more in the future!");
		allItemsBoughtDescription_m.tintTopLeft = 5387071;
		allItemsBoughtDescription_m.tintTopRight = 5387071;
		allItemsBoughtDescription_m.tintBottomLeft = 5387071;
		allItemsBoughtDescription_m.tintBottomRight = 5387071;
		allItemsBoughtDescription_m.text = "You already own all the items in this category. We will add more in the future!";
		allItemsBoughtDescription_m.fontSize = -16;
		allItemsBoughtDescription_m.maxWidth = 400;
		allItemsBoughtContainer_m.add(allItemsBoughtDescription_m);

		// shopIcon_m
		const shopIcon_m = this.add.image(44, 48, "shop1");
		shopIcon_m.scaleX = 2;
		shopIcon_m.scaleY = 2;
		allItemsBoughtContainer_m.add(shopIcon_m);

		// crossIcon_m
		const crossIcon_m = this.add.image(44, 48, "hud-icons", 133);
		crossIcon_m.scaleX = 2;
		crossIcon_m.scaleY = 2;
		allItemsBoughtContainer_m.add(crossIcon_m);

		// categoryHeader_m
		const categoryHeader_m = this.add.container(292, 23);
		categoryHeader_m.visible = false;
		mainShopGrid_m.add(categoryHeader_m);

		// nineslice_m
		const nineslice_m = this.add.nineslice(0, 2, "Hud2", undefined, 64, 24, 4, 4, 4, 4);
		nineslice_m.scaleX = 2;
		nineslice_m.scaleY = 2;
		categoryHeader_m.add(nineslice_m);

		// categoryHeaderText_m
		const categoryHeaderText_m = this.add.bitmapText(0, 2, "Aronui", "Clothes");
		categoryHeaderText_m.setOrigin(0.5, 0.5);
		categoryHeaderText_m.tintTopLeft = 3023407;
		categoryHeaderText_m.tintTopRight = 3023407;
		categoryHeaderText_m.tintBottomLeft = 3023407;
		categoryHeaderText_m.tintBottomRight = 3023407;
		categoryHeaderText_m.text = "Clothes";
		categoryHeaderText_m.fontSize = -18;
		categoryHeader_m.add(categoryHeaderText_m);

		// currency_m
		const currency_m = this.add.container(146, -100);
		mainShopContainer_m.add(currency_m);

		// currencyBacking_m
		const currencyBacking_m = this.add.nineslice(22, 16, "backingFadeOut_m", undefined, 59, 0, 10, 10, 0, 0);
		currencyBacking_m.scaleX = 2;
		currencyBacking_m.scaleY = 2;
		currencyBacking_m.setOrigin(0, 0.5);
		currency_m.add(currencyBacking_m);

		// ruby-icon_m
		const ruby_icon_m = this.add.image(22, 16, "hud-icons", 95);
		ruby_icon_m.scaleX = 2;
		ruby_icon_m.scaleY = 2;
		currency_m.add(ruby_icon_m);

		// playerRubiesText_m
		const playerRubiesText_m = this.add.bitmapText(128, 16, "Aronui", "-");
		playerRubiesText_m.setOrigin(1, 0.5);
		playerRubiesText_m.tintTopLeft = 15130076;
		playerRubiesText_m.tintTopRight = 15130076;
		playerRubiesText_m.tintBottomLeft = 15130076;
		playerRubiesText_m.tintBottomRight = 15130076;
		playerRubiesText_m.text = "-";
		playerRubiesText_m.fontSize = -24;
		playerRubiesText_m.align = 2;
		currency_m.add(playerRubiesText_m);

		// closeButtonContainer_m
		const closeButtonContainer_m = this.add.container(302, -156);
		mainShopContainer_m.add(closeButtonContainer_m);

		// closeButton_m
		const closeButton_m = new HUDButton(this, -28, 28, "hud-icons", 245);
		closeButtonContainer_m.add(closeButton_m);

		// itemViewModal_m
		const itemViewModal_m = this.add.container(334, 188);
		mobileView.add(itemViewModal_m);

		// itemViewBacking_m
		const itemViewBacking_m = this.add.image(0, 0, "1x1sprite");
		itemViewBacking_m.scaleX = 2048;
		itemViewBacking_m.scaleY = 1536;
		itemViewBacking_m.alpha = 0.5;
		itemViewBacking_m.alphaTopLeft = 0.5;
		itemViewBacking_m.alphaTopRight = 0.5;
		itemViewBacking_m.alphaBottomLeft = 0.5;
		itemViewBacking_m.alphaBottomRight = 0.5;
		itemViewBacking_m.tintTopLeft = 985612;
		itemViewBacking_m.tintTopRight = 985612;
		itemViewBacking_m.tintBottomLeft = 985612;
		itemViewBacking_m.tintBottomRight = 985612;
		itemViewModal_m.add(itemViewBacking_m);

		// itemViewContainer_m
		const itemViewContainer_m = this.add.container(0, 0);
		itemViewModal_m.add(itemViewContainer_m);

		// itemViewContainerBG_m
		const itemViewContainerBG_m = this.add.nineslice(0, 0, "Hud1", undefined, 200, 148, 8, 8, 8, 8);
		itemViewContainerBG_m.scaleX = 2;
		itemViewContainerBG_m.scaleY = 2;
		itemViewContainer_m.add(itemViewContainerBG_m);

		// itemIconContainer_m
		const itemIconContainer_m = this.add.container(0, 5);
		itemViewContainer_m.add(itemIconContainer_m);

		// itemIconBacking_m
		const itemIconBacking_m = this.add.image(0, 0, "shopItemBacking_128-1");
		itemIconBacking_m.scaleX = 2;
		itemIconBacking_m.scaleY = 2;
		itemIconContainer_m.add(itemIconBacking_m);

		// itemViewRarityFrame_m
		const itemViewRarityFrame_m = this.add.image(0, 0, "shopItemBacking_128-2");
		itemViewRarityFrame_m.scaleX = 2;
		itemViewRarityFrame_m.scaleY = 2;
		itemIconContainer_m.add(itemViewRarityFrame_m);

		// itemView_m
		const itemView_m = this.add.image(0, 0, "ui-black-high-boots-large");
		itemView_m.scaleX = 2;
		itemView_m.scaleY = 2;
		itemIconContainer_m.add(itemView_m);

		// playerContainer_m
		const playerContainer_m = this.add.container(-118, -15);
		itemViewContainer_m.add(playerContainer_m);

		// playerBacking_m
		const playerBacking_m = this.add.nineslice(0, 0, "panel segment", undefined, 52, 84, 4, 4, 4, 4);
		playerBacking_m.scaleX = 2;
		playerBacking_m.scaleY = 2;
		playerContainer_m.add(playerBacking_m);

		// image_8_m
		const image_8_m = this.add.image(0, 0, "zone-snippet");
		image_8_m.scaleX = 0.66;
		image_8_m.scaleY = 0.66;
		playerContainer_m.add(image_8_m);

		// playerDoll_m
		const playerDoll_m = new PlayerDoll(this, 0, 0);
		playerDoll_m.scaleX = 4;
		playerDoll_m.scaleY = 4;
		playerContainer_m.add(playerDoll_m);

		// itemPricingContainer_m
		const itemPricingContainer_m = this.add.container(66, -59);
		itemViewContainer_m.add(itemPricingContainer_m);

		// itemIconBacking_2_m
		const itemIconBacking_2_m = this.add.nineslice(0, 0, "panel segment", undefined, 52, 64, 4, 4, 4, 8);
		itemIconBacking_2_m.scaleX = 2;
		itemIconBacking_2_m.scaleY = 2;
		itemIconBacking_2_m.setOrigin(0, 0);
		itemPricingContainer_m.add(itemIconBacking_2_m);

		// priceContainer_m
		const priceContainer_m = this.add.container(8, 8);
		itemPricingContainer_m.add(priceContainer_m);

		// itemPriceLabel_m
		const itemPriceLabel_m = this.add.bitmapText(0, 0, "Aronui", "Price:");
		itemPriceLabel_m.tintTopLeft = 5387071;
		itemPriceLabel_m.tintTopRight = 5387071;
		itemPriceLabel_m.tintBottomLeft = 5387071;
		itemPriceLabel_m.tintBottomRight = 5387071;
		itemPriceLabel_m.text = "Price:";
		itemPriceLabel_m.fontSize = -16;
		itemPriceLabel_m.maxWidth = 120;
		priceContainer_m.add(itemPriceLabel_m);

		// currency_2_m
		const currency_2_m = this.add.container(0, 16);
		priceContainer_m.add(currency_2_m);

		// currencyBacking_1_m
		const currencyBacking_1_m = this.add.nineslice(16, 16, "backingFadeOut", undefined, 24, 0, 10, 10, 0, 0);
		currencyBacking_1_m.scaleX = 4;
		currencyBacking_1_m.scaleY = 4;
		currencyBacking_1_m.setOrigin(0, 0.5);
		currencyBacking_1_m.visible = false;
		currency_2_m.add(currencyBacking_1_m);

		// ruby-icon_4
		const ruby_icon_4 = this.add.image(13, 16, "hud-icons", 95);
		ruby_icon_4.scaleX = 2;
		ruby_icon_4.scaleY = 2;
		currency_2_m.add(ruby_icon_4);

		// itemPriceText_m
		const itemPriceText_m = this.add.bitmapText(28, 16, "Aronui", "-");
		itemPriceText_m.setOrigin(0, 0.5);
		itemPriceText_m.tintTopLeft = 15130076;
		itemPriceText_m.tintTopRight = 15130076;
		itemPriceText_m.tintBottomLeft = 15130076;
		itemPriceText_m.tintBottomRight = 15130076;
		itemPriceText_m.text = "-";
		itemPriceText_m.fontSize = -16;
		currency_2_m.add(itemPriceText_m);

		// availableFundsContainer_m
		const availableFundsContainer_m = this.add.container(10, 68);
		itemPricingContainer_m.add(availableFundsContainer_m);

		// currency_3_m
		const currency_3_m = this.add.container(0, 20);
		availableFundsContainer_m.add(currency_3_m);

		// currencyBacking_2_m
		const currencyBacking_2_m = this.add.nineslice(16, 16, "backingFadeOut", undefined, 24, 0, 10, 10, 0, 0);
		currencyBacking_2_m.scaleX = 4;
		currencyBacking_2_m.scaleY = 4;
		currencyBacking_2_m.setOrigin(0, 0.5);
		currencyBacking_2_m.visible = false;
		currency_3_m.add(currencyBacking_2_m);

		// ruby-icon_3_m
		const ruby_icon_3_m = this.add.image(13, 16, "hud-icons", 95);
		ruby_icon_3_m.scaleX = 2;
		ruby_icon_3_m.scaleY = 2;
		currency_3_m.add(ruby_icon_3_m);

		// playerRubiesText_1_m
		const playerRubiesText_1_m = this.add.bitmapText(28, 16, "Aronui", "-");
		playerRubiesText_1_m.setOrigin(0, 0.5);
		playerRubiesText_1_m.tintTopLeft = 15130076;
		playerRubiesText_1_m.tintTopRight = 15130076;
		playerRubiesText_1_m.tintBottomLeft = 15130076;
		playerRubiesText_1_m.tintBottomRight = 15130076;
		playerRubiesText_1_m.text = "-";
		playerRubiesText_1_m.fontSize = -16;
		currency_3_m.add(playerRubiesText_1_m);

		// availableFundsLabel_m
		const availableFundsLabel_m = this.add.bitmapText(-2, 2, "Aronui", "You have:");
		availableFundsLabel_m.tintTopLeft = 5387071;
		availableFundsLabel_m.tintTopRight = 5387071;
		availableFundsLabel_m.tintBottomLeft = 5387071;
		availableFundsLabel_m.tintBottomRight = 5387071;
		availableFundsLabel_m.text = "You have:";
		availableFundsLabel_m.fontSize = -16;
		availableFundsLabel_m.maxWidth = 120;
		availableFundsContainer_m.add(availableFundsLabel_m);

		// itemViewHeaderContainer_m
		const itemViewHeaderContainer_m = this.add.container(2, -144);
		itemViewContainer_m.add(itemViewHeaderContainer_m);

		// itemViewHeaderBG_m
		const itemViewHeaderBG_m = this.add.nineslice(0, 0, "Hud2", undefined, 100, 22, 4, 4, 4, 4);
		itemViewHeaderBG_m.scaleX = 2;
		itemViewHeaderBG_m.scaleY = 2;
		itemViewHeaderContainer_m.add(itemViewHeaderBG_m);

		// itemViewTitle_m
		const itemViewTitle_m = this.add.bitmapText(0, 0, "Aronui", "Purchase Item");
		itemViewTitle_m.setOrigin(0.5, 0.5);
		itemViewTitle_m.tintTopLeft = 3023407;
		itemViewTitle_m.tintTopRight = 3023407;
		itemViewTitle_m.tintBottomLeft = 3023407;
		itemViewTitle_m.tintBottomRight = 3023407;
		itemViewTitle_m.text = "Purchase Item";
		itemViewTitle_m.fontSize = -24;
		itemViewHeaderContainer_m.add(itemViewTitle_m);

		// buttonContainer_m
		const buttonContainer_m = this.add.container(0, 106);
		itemViewContainer_m.add(buttonContainer_m);

		// itemViewAcceptButton_m
		const itemViewAcceptButton_m = new DefaultConfirmButton_m(this, 0, 0);
		buttonContainer_m.add(itemViewAcceptButton_m);

		// closeButtonContainer_m_1
		const closeButtonContainer_m_1 = this.add.container(200, -148);
		itemViewContainer_m.add(closeButtonContainer_m_1);

		// closeButton_1_m
		const closeButton_1_m = new HUDButton(this, -24, 24, "hud-icons", 245);
		closeButtonContainer_m_1.add(closeButton_1_m);

		// itemInfoContainer_m
		const itemInfoContainer_m = this.add.container(72, -85);
		itemViewContainer_m.add(itemInfoContainer_m);

		// nineslice_3
		const nineslice_3 = this.add.nineslice(-136, -14, "panel segment", undefined, 117, 19, 5, 5, 5, 5);
		nineslice_3.scaleX = 2;
		nineslice_3.scaleY = 2;
		nineslice_3.setOrigin(0, 0);
		itemInfoContainer_m.add(nineslice_3);

		// itemViewItemName_m
		const itemViewItemName_m = this.add.bitmapText(-128, -1, "Aronui", "Black Boots");
		itemViewItemName_m.tintTopLeft = 3023407;
		itemViewItemName_m.tintTopRight = 3023407;
		itemViewItemName_m.tintBottomLeft = 3023407;
		itemViewItemName_m.tintBottomRight = 3023407;
		itemViewItemName_m.text = "Black Boots";
		itemViewItemName_m.fontSize = -16;
		itemViewItemName_m.maxWidth = 500;
		itemInfoContainer_m.add(itemViewItemName_m);

		// rarityBacking_m
		const rarityBacking_m = this.add.nineslice(0, 0, "backingFadeOut", undefined, 36, 8, 4, 4, 4, 4);
		rarityBacking_m.scaleX = 4;
		rarityBacking_m.scaleY = 4;
		rarityBacking_m.setOrigin(0, 0);
		rarityBacking_m.visible = false;
		itemInfoContainer_m.add(rarityBacking_m);

		// rarityText_m
		const rarityText_m = this.add.bitmapText(-128, -4, "Aronui", "Common");
		rarityText_m.setOrigin(0, 0.5);
		rarityText_m.tintTopLeft = 2989040;
		rarityText_m.tintTopRight = 2989040;
		rarityText_m.tintBottomLeft = 2989040;
		rarityText_m.tintBottomRight = 2989040;
		rarityText_m.text = "Common";
		rarityText_m.fontSize = -12;
		rarityText_m.maxWidth = 140;
		itemInfoContainer_m.add(rarityText_m);

		// purchaseNotificationOrigin_m
		const purchaseNotificationOrigin_m = this.add.container(668, 76);
		mobileView.add(purchaseNotificationOrigin_m);

		// purchaseNotification_m
		const purchaseNotification_m = new PurchaseNotification(this, 0, 0);
		purchaseNotification_m.scaleX = 0.5;
		purchaseNotification_m.scaleY = 0.5;
		purchaseNotification_m.visible = true;
		purchaseNotificationOrigin_m.add(purchaseNotification_m);

		// leaveButton (prefab fields)
		leaveButton.buttonText = "Exit";

		// itemViewAcceptButton (prefab fields)
		itemViewAcceptButton.buttonText = "Buy";

		// itemViewAcceptButton_m (prefab fields)
		itemViewAcceptButton_m.buttonText = "Buy";

		this.leaveButton = leaveButton;
		this.shopTabs = shopTabs;
		this.gridBacking = gridBacking;
		this.scrollBarBacking = scrollBarBacking;
		this.scrollBarHandle = scrollBarHandle;
		this.content = content;
		this.spinnerBlocker = spinnerBlocker;
		this.loadingSpinner = loadingSpinner;
		this.loadingContainer = loadingContainer;
		this.categoryHeaderText = categoryHeaderText;
		this.allItemsBoughtContainer = allItemsBoughtContainer;
		this.playerRubiesText = playerRubiesText;
		this.closeButton = closeButton;
		this.mainContainer = mainContainer;
		this.purchaseNotification = purchaseNotification;
		this.purchaseNotificationOrigin = purchaseNotificationOrigin;
		this.itemViewBacking = itemViewBacking;
		this.itemViewAcceptButton = itemViewAcceptButton;
		this.itemView = itemView;
		this.itemViewRarityFrame = itemViewRarityFrame;
		this.itemViewItemName = itemViewItemName;
		this.itemPriceText = itemPriceText;
		this.playerRubiesText_1 = playerRubiesText_1;
		this.rarityText = rarityText;
		this.playerDoll = playerDoll;
		this.closeButton_1 = closeButton_1;
		this.itemViewModal = itemViewModal;
		this.desktopView = desktopView;
		this.shopTabs_m = shopTabs_m;
		this.gridBacking_m = gridBacking_m;
		this.content_m = content_m;
		this.scrollBarBacking_m = scrollBarBacking_m;
		this.scrollBarHandle_m = scrollBarHandle_m;
		this.spinnerBlocker_m = spinnerBlocker_m;
		this.loadingSpinner_m = loadingSpinner_m;
		this.loadingContainer_m = loadingContainer_m;
		this.allItemsBoughtContainer_m = allItemsBoughtContainer_m;
		this.categoryHeaderText_m = categoryHeaderText_m;
		this.playerRubiesText_m = playerRubiesText_m;
		this.closeButton_m = closeButton_m;
		this.mainContainer_m = mainContainer_m;
		this.itemViewBacking_m = itemViewBacking_m;
		this.itemViewRarityFrame_m = itemViewRarityFrame_m;
		this.itemView_m = itemView_m;
		this.playerDoll_m = playerDoll_m;
		this.itemPriceText_m = itemPriceText_m;
		this.playerRubiesText_1_m = playerRubiesText_1_m;
		this.itemViewAcceptButton_m = itemViewAcceptButton_m;
		this.closeButton_1_m = closeButton_1_m;
		this.itemViewItemName_m = itemViewItemName_m;
		this.rarityText_m = rarityText_m;
		this.itemViewModal_m = itemViewModal_m;
		this.purchaseNotification_m = purchaseNotification_m;
		this.purchaseNotificationOrigin_m = purchaseNotificationOrigin_m;
		this.mobileView = mobileView;

		this.events.emit("scene-awake");
	}

	public leaveButton!: DefaultButton;
	public shopTabs!: Phaser.GameObjects.Container;
	public gridBacking!: Phaser.GameObjects.NineSlice;
	public scrollBarBacking!: Phaser.GameObjects.NineSlice;
	public scrollBarHandle!: Phaser.GameObjects.Image;
	public content!: Phaser.GameObjects.Container;
	public spinnerBlocker!: Phaser.GameObjects.Image;
	public loadingSpinner!: Phaser.GameObjects.Image;
	public loadingContainer!: Phaser.GameObjects.Container;
	public categoryHeaderText!: Phaser.GameObjects.BitmapText;
	public allItemsBoughtContainer!: Phaser.GameObjects.Container;
	public playerRubiesText!: Phaser.GameObjects.BitmapText;
	public closeButton!: HUDButton;
	public mainContainer!: Phaser.GameObjects.Container;
	public purchaseNotification!: PurchaseNotification;
	public purchaseNotificationOrigin!: Phaser.GameObjects.Container;
	public itemViewBacking!: Phaser.GameObjects.Image;
	public itemViewAcceptButton!: DefaultButton;
	public itemView!: Phaser.GameObjects.Image;
	public itemViewRarityFrame!: Phaser.GameObjects.NineSlice;
	public itemViewItemName!: Phaser.GameObjects.BitmapText;
	public itemPriceText!: Phaser.GameObjects.BitmapText;
	public playerRubiesText_1!: Phaser.GameObjects.BitmapText;
	public rarityText!: Phaser.GameObjects.BitmapText;
	public playerDoll!: PlayerDoll;
	public closeButton_1!: HUDButton;
	public itemViewModal!: Phaser.GameObjects.Container;
	public desktopView!: Phaser.GameObjects.Container;
	public shopTabs_m!: Phaser.GameObjects.Container;
	public gridBacking_m!: Phaser.GameObjects.NineSlice;
	public content_m!: Phaser.GameObjects.Container;
	public scrollBarBacking_m!: Phaser.GameObjects.NineSlice;
	public scrollBarHandle_m!: Phaser.GameObjects.Image;
	public spinnerBlocker_m!: Phaser.GameObjects.Image;
	public loadingSpinner_m!: Phaser.GameObjects.Image;
	public loadingContainer_m!: Phaser.GameObjects.Container;
	public allItemsBoughtContainer_m!: Phaser.GameObjects.Container;
	public categoryHeaderText_m!: Phaser.GameObjects.BitmapText;
	public playerRubiesText_m!: Phaser.GameObjects.BitmapText;
	public closeButton_m!: HUDButton;
	public mainContainer_m!: Phaser.GameObjects.Container;
	public itemViewBacking_m!: Phaser.GameObjects.Image;
	public itemViewRarityFrame_m!: Phaser.GameObjects.Image;
	public itemView_m!: Phaser.GameObjects.Image;
	public playerDoll_m!: PlayerDoll;
	public itemPriceText_m!: Phaser.GameObjects.BitmapText;
	public playerRubiesText_1_m!: Phaser.GameObjects.BitmapText;
	public itemViewAcceptButton_m!: DefaultConfirmButton_m;
	public closeButton_1_m!: HUDButton;
	public itemViewItemName_m!: Phaser.GameObjects.BitmapText;
	public rarityText_m!: Phaser.GameObjects.BitmapText;
	public itemViewModal_m!: Phaser.GameObjects.Container;
	public purchaseNotification_m!: PurchaseNotification;
	public purchaseNotificationOrigin_m!: Phaser.GameObjects.Container;
	public mobileView!: Phaser.GameObjects.Container;

	/* START-USER-CODE */

  create() {
    this.editorCreate();
    this.itemViewModal.setVisible(false);
    this.itemViewModal_m.setVisible(false);
    new CosmeticShopController(this);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */
